import React from 'react'
import './Dashboard.css'
import logo from '../../assets/img/logo.png'
import heroNew from '../../assets/img/hero-new.png'
import screenStandard from '../../assets/vectors/screen-standard.svg'
import screenPro from '../../assets/vectors/screen-pro.svg'
import screenCollection from '../../assets/vectors/screen-collection.svg'

import { ArrowDropDownRounded, Add, Delete, DeleteOutline, Grade } from '@material-ui/icons'
import { API_URL } from '../../config'
import axios from 'axios'

import * as firebase from "firebase/app"
import "firebase/auth"
import PaygeListItem from '../../components/PaygeListItem/PaygeListItem'

const quick_steps = [
  "Click on the button below",
  "Paste shareable link of the file to download",
  "Select page theme & Generate download page"
]

const my_payges = [
  ["Google Calendar by desko", "payge.io/jgs2f53GuH", 102],
  ["Gmail by desko", "payge.io/bEh23SAjh", 54],
  ["Asana by desko", "payge.io/Yh32AmsIK", 729]
]

export default class Dashboard extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      copiedIndex: undefined,
      profileOpen: false,
      userUid: undefined,
      userDisplayName: '',
      userPayges: [],
      activeMyPaygeTab: 0,
      standardPayges: [],
      proPayges: [],
      collectionPayges: [],
    }
  }

  toggleProfileOptions = () => {
    let profileToggle = false
    if (!this.state.profileOpen) {
      profileToggle = true
    }
    this.setState({
      profileOpen: profileToggle
    })
  }

  copyLinkToClipboard = (link, index) => {
    let context = this
    navigator.permissions.query({name: "clipboard-write"}).then(result => {
      if (result.state == "granted" || result.state == "prompt") {
        // writing link to clipboard
        navigator.clipboard.writeText(link).then(function() {
          console.log("clipboard copied")
          // quick UI changes
          context.showCopyUIChanges(index)
        }, function() {
          console.log("clipboard error")
        });
      }
    });
  }

  showCopyUIChanges = (index) => {
    this.setState({copiedIndex: index})
    setTimeout(() => {
      this.setState({copiedIndex: undefined})
    }, 500)
  }
  
  // delete payge API request
  deletePaygeFromDB = (payge, activeType) => {
    const { userUid, standardPayges, proPayges, collectionPayges } = this.state
    const id = payge.id
    if (window.confirm(`You're going to delete ${activeType === 'pro' ? payge.paygeDetails.landing.title : payge.paygeDetails.name} payge!`)) {
      // calling the API
      let url = `${API_URL}/payge/${id}/delete`
      axios({
        method: 'DELETE',
        url: url,
        headers: {
          'Authorization': userUid
        }
      })
      .then((result) => {
        if (result.status === 200) {
          // removing item from list
          let index = -1
          switch (activeType) {
            case 'standard':
              index = standardPayges.map(p => p.id).indexOf(id)
              standardPayges.splice(index, 1)
              this.setState({standardPayges: standardPayges})
              break
            case 'pro':
              index = proPayges.map(p => p.id).indexOf(id)
              proPayges.splice(index, 1)
              this.setState({proPayges: proPayges})
              break
            case 'collection':
              index = collectionPayges.map(p => p.id).indexOf(id)
              collectionPayges.splice(index, 1)
              this.setState({collectionPayges: collectionPayges})
              break
          }
        }
      })
    }
  }

  // user sign out
  signOut = () => {
    firebase.auth().signOut().then(function() {
      window.open('/', '_self')
    }).catch(function(error) {
      // An error happened.
    });
  }

  getUserPayges = (uid) => {
    // getting user payges
    axios(`${API_URL}/user/${uid}/payges`)
    .then((result) => {
      if (result.status === 200) {
        if (result.data.status === "success") {
          let payges = result.data.userPayges
          // payges.reverse()
          let standardPayges = []
          let proPayges = []
          let collectionPayges = []
          payges.map(payge => {
            switch (payge.paygeType) {
              case 'standard':
                standardPayges.push(payge)
                break
              case 'pro':
                proPayges.push(payge)
                break
              case 'collection':
                collectionPayges.push(payge)
            }
          })
          this.setState({
            standardPayges: standardPayges,
            proPayges: proPayges,
            collectionPayges: collectionPayges
          })
        }
      }
    })
  }

  componentWillMount() {
    let self = this
    // firebase auth listener
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        let uid = user.uid
        self.setState({userUid: uid, userDisplayName: user.displayName})
        // getting user payges
        self.getUserPayges(uid)

      } else {
        // User is signed out.
        window.open('/', '_self')
        return
      }
    })
  }

  componentDidMount() {
    // getting freshdesk
		const script = document.createElement("script")
    script.innerHTML = `function initFreshChat() {
			window.fcWidget.init({
				token: "fb1434a6-ddb7-4222-b6fa-16f3b83e457e",
				host: "https://wchat.in.freshchat.com"
			});
		}
		function initialize(i,t){var e;i.getElementById(t)?initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,e.src="https://wchat.in.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}function initiateCall(){initialize(document,"freshchat-js-sdk")}window.addEventListener?window.addEventListener("load",initiateCall,!1):window.attachEvent("load",initiateCall,!1);`
    script.async = true
    document.body.appendChild(script)
  }

  render() {
    const { copiedIndex, profileOpen, userUid, userPayges, userDisplayName, activeMyPaygeTab,
      standardPayges, proPayges, collectionPayges } = this.state

    let activePayges = []
    let activeType = 'standard'
    switch (activeMyPaygeTab) {
      case 0:
        activePayges = standardPayges
        activeType = 'standard'
        break
      case 1:
        activePayges = proPayges
        activeType = 'pro'
        break
      case 2: 
        activePayges = collectionPayges
        activeType = 'collection'
    }

    return (
      <>
        {
          userUid ? (
            <>
              <section className="dashboard-topbar">
                <a href="/"><div className="logo">
                  <img src={logo} className="logo-img" />
                  <span className="page-title">Payge</span>
                </div></a>
                <div style={{display:'flex', justifyContent: 'flex-end'}}>
                  <div className="profile-section-top" onClick={this.toggleProfileOptions.bind(this)}>
                    <span className="name-text">My Account</span><ArrowDropDownRounded />
                  </div>
                  <ul className={"account-dropdown " + profileOpen}>
                    <li><span className="name">{userDisplayName ? userDisplayName : "Hi Payger"}</span></li>
                    <li onClick={this.signOut.bind(this)}><span>Log Out</span></li>
                  </ul>
                </div>
              </section>

              <section id="create-new-section">
                <img src={heroNew} className="hero-img"/>
                <div className="create-action-container">
                  {/* <span className="info-text">
                    Quickly generate a download payge by clicking the button below and pasting the shareable link to the file in Google Drive in the page that follows.
                  </span> */}
                  <ul className="quick-steps">
                    {
                      quick_steps.map((step, index) => {
                        return (
                          <li>
                            <span className="count">{index+1}</span>
                            <span className="text">{step}</span>
                          </li>
                        )
                      })
                    }
                  </ul>
                  <a href="/creator" style={{textDecoration: 'none'}}>
                    <div style={{display: 'flex', flexDirection: 'row'}}><div className="new-payge-button">
                      <Add className="icon"/> Create download page
                    </div></div>
                  </a>
                </div>
              </section>

              <section id="mypages-section">
                <span className="mypages-title">My Payges</span>
                <div className="mypages-table-container">
                  <span className="device-support">Please use the desktop version to view your payges.</span>
                  {
                    userPayges.length > 0 ? (
                      <>
                        <tr className="headers">
                          <th className="name">Name</th>
                          <th className="link">Payge Link</th>
                          <th className="count">Downloads</th>
                          <th className="count">Pageviews</th>
                        </tr>
                        {
                          userPayges.map((payge, index) => {
                            let copy_text = "Copy to clipboard"
                            if (copiedIndex === index) {
                              copy_text = "copied"
                            }
                            return (
                              <tr>
                                <td className="name">
                                  {payge.paygeDetails.name}
                                  <DeleteOutline className="delete-icon" onClick={()=>this.deletePaygeFromDB(payge, index)}/>
                                </td>
                                <td className="link">
                                  <a href={payge.paygeUrl} target="_blank" style={{textDecoration: 'none'}}>{payge.paygeUrl.slice(8)}</a><span className="copy" onClick={() => this.copyLinkToClipboard(payge.paygeUrl, index)}>{copy_text}</span>
                                </td>
                                <td className="count">{payge.downloadCount}</td>
                                <td className="count">{payge.viewCount}</td>
                              </tr>
                            )
                          })
                        }
                      </>
                    ) : (
                      <span className="zero-payges">You have not created any payges. Start creating now!</span>
                    )
                  }
                </div>
              </section>

              <section id="create-section">
                <span className="title"><Add className="icon"/> Create a new Payge</span>

                <ul className="create-choices">
                  <li className="standard" onClick={()=>window.open('/creator/standard', '_self')}>
                    <div className="text-container">
                      <span className="item-title">Standard Payge</span>
                      <span className="item-description">A simple, clean download page for quick and easy sharing</span>

                      <span className="best-for-text">Best for</span>
                      <span className="best-content"><Grade className="icon" />Quick file sharing</span>
                    </div>
                    <img src={screenStandard} className="item-img" />
                  </li>
                  <li className="pro" onClick={()=>window.open('/creator/pro', '_self')}>
                    <div className="text-container">
                      <span className="item-title">Pro Payge</span>
                      <span className="item-description">A new and professional way to share and present files.</span>

                      <span className="best-for-text">Best for</span>
                      <span className="best-content"><Grade className="icon" />Selling your files</span>
                    </div>
                    <img src={screenPro} className="item-img" />
                  </li>
                  <li className="collection">
                    <div className="text-container">
                      <span className="item-title">Collection Payge</span>
                      <span className="item-description">A single download page for sharing all your files.</span>

                      <span className="best-for-text">Best for</span>
                      <span className="best-content"><Grade className="icon" />Sharing multiple files</span>
                    </div>
                    <img src={screenCollection} className="item-img" />
                  </li>
                </ul>
              </section>

              <section id="all-payges-section">
                <span className="section-title">My Payges</span>
                <ul className="payge-type-selections">
                  <li 
                    className={activeMyPaygeTab === 0 ? 'active' : 'inactive'} 
                    onClick={()=>this.setState({activeMyPaygeTab: 0})}>
                    <span>Standard</span>
                    <div className="indicator" />
                  </li>
                  <li 
                    className={activeMyPaygeTab === 1 ? 'active' : 'inactive'}
                    onClick={()=>this.setState({activeMyPaygeTab: 1})}>
                    <span>Pro</span>
                    <div className="indicator" />
                  </li>
                  <li 
                    className={activeMyPaygeTab === 2 ? 'active' : 'inactive'}
                    onClick={()=>this.setState({activeMyPaygeTab: 2})}>
                    <span>Collection</span>
                    <div className="indicator" />
                  </li>
                </ul>
                <ul className="payge-list">
                  {
                    activePayges.map(payge => (
                      <PaygeListItem 
                        key={payge.id}
                        payge={payge}
                        currentType={activeType}
                        onDelete={this.deletePaygeFromDB} />
                    ))
                  }
                </ul>
              </section>

              {/* <section id="footer-section">
                <img src={yashLogo} className="yash-logo" />
              </section> */}
            </>
          ) : false
        }
      </>
    )
  }

}